
/**
 * Stripe API configuration
 */

// Stripe API configuration - use the same key across all services
export const STRIPE_PUBLIC_KEY = 'pk_test_51P4Y55FSLIRqJGEMmJpxCTBaIL8hVDPOFV1ULgZLXB4dYKO26JT5AkUYuTjz4mZmEI0Ck0B1oRVl67PpDsn7HqiT00zz8JTIht';

// Define a type for the Stripe global object to satisfy TypeScript
// Global type definitions moved to global.d.ts
